import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  acceptLegalDocuments,
  getLegalDocument,
  getMyLegalAcceptances,
  type LegalAcceptanceInput,
} from '@nomiss/services';

export const legalQueryKeys = {
  document: (kind: 'terms' | 'privacy', lang?: string) =>
    ['account', 'legal', kind, lang ?? ''] as const,
  acceptances: ['account', 'legal', 'acceptances'] as const,
};

export function useLegalDocument(
  kind: 'terms' | 'privacy',
  lang?: string,
  enabled = true,
) {
  return useQuery({
    queryKey: legalQueryKeys.document(kind, lang),
    queryFn: () => getLegalDocument(kind, lang),
    enabled,
  });
}

export function useMyLegalAcceptances(
  accessToken?: string | null,
  enabled = true,
) {
  return useQuery({
    queryKey: legalQueryKeys.acceptances,
    queryFn: () => getMyLegalAcceptances(accessToken),
    enabled: Boolean(accessToken) && enabled,
  });
}

export function useAcceptLegalDocuments() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (acceptances: LegalAcceptanceInput[]) =>
      acceptLegalDocuments(acceptances),
    onSuccess: data => {
      queryClient.setQueryData(legalQueryKeys.acceptances, data);
    },
  });
}
